import { attach, createEvent, sample } from "effector";
import { operationName } from "../lib/name.mjs";
import { optional } from "../lib/optional.mjs";
import { storify } from "../lib/storify.mjs";
import { createRemoteOperation } from "../remote_operation.mjs";
function createMutation({
  client,
  document,
  context,
  name = operationName(document) || "unknown"
}) {
  const $client = storify(client, { name: `${name}.client`, sid: `apollo.${name}.$client` });
  const $context = storify(context, { name: `${name}.context`, sid: `apollo.${name}.$context` });
  const handler = attach({
    source: { client: $client, context: $context },
    effect: ({ client: client2, context: context2 }, { variables }) => client2.mutate({ mutation: document, context: context2, variables, fetchPolicy: "network-only" }).then(({ data }) => data)
  });
  const operation = createRemoteOperation({ name, handler });
  const start = createEvent({ name: `${name}.start` });
  sample({
    clock: start,
    fn: (variables) => ({ variables }),
    target: operation.__.execute
  });
  return {
    ...operation,
    start: optional(start),
    meta: { name, client: $client, document },
    __: { ...operation.__ }
  };
}
export {
  createMutation
};
//# sourceMappingURL=mutation.mjs.map
